import React from "react";

const STAFF = [
  {
    name: "Jerry Volmer",
    role: "Co-Owner",
    bio: "Hospitality leader with decades of experience across multiple markets — guides the vision and direction of Next.",
    image: "https://customer-assets-7cd3h4nn.emergentagent.net/job_venue-events-hub/artifacts/tnbwxnhb_IMG_3109.jpg",
  },
  {
    name: "Deiler Beltran",
    role: "Co-Owner",
    bio: "Longtime Wilton Manors hospitality professional with deep bartending and local industry roots.",
    image: "https://customer-assets.emergentagent.com/job_venue-events-hub/artifacts/rvewnxzv_IMG_1523.jpg",
  },
  {
    name: "Javier Montero",
    role: "Co-Owner",
    bio: "Community-rooted hospitality professional who refined his craft behind the bar in Wilton Manors.",
    image: "https://customer-assets.emergentagent.com/job_venue-events-hub/artifacts/b3rty6r6_IMG_1522%202.jpg",
  },
];

export default function Staff() {
  return (
    <section id="staff" data-testid="staff-section" className="relative py-24 md:py-32 bg-neutral-900">
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-16 max-w-4xl">
        <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-4">Our Team</p>
        <h2 className="font-serif font-light text-white text-4xl md:text-5xl lg:text-6xl tracking-tight">
          The owners <span className="italic text-[#D4AF37]">behind Next</span>
        </h2>
        <p className="mt-6 text-neutral-400 leading-relaxed max-w-2xl">
          Three hospitality professionals with deep roots in Wilton Manors — together they shape the vision, the bar
          program and the energy that makes Next feel like home.
        </p>
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {STAFF.map((s, i) => (
            <article key={s.name} data-testid={`staff-card-${i}`} className="group">
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={s.image}
                  alt={s.name}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                />
                <div className="absolute inset-0 ring-1 ring-inset ring-white/10 group-hover:ring-[#D4AF37]/50 transition-colors" />
              </div>
              <h3 className="font-serif text-2xl md:text-3xl text-white mt-6 tracking-tight">{s.name}</h3>
              <p className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37] mt-2">{s.role}</p>
              <p className="mt-4 text-sm text-neutral-400 leading-relaxed">{s.bio}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
